import axios from 'axios';
import { useQuery } from 'react-query';

import { Warrior } from '~/../api/common.types';

export const useGetWarrior = (id) => {
  const apiHost = process.env.NEXT_PUBLIC_API_HOST;
  return useQuery<Warrior | undefined, Error>(['warriors', id], async () => {
    const { data } = await axios({
      url: `${apiHost}/warriors/${id}`,
      method: 'get',
    });
    return data;
  });
};
